<template>
  <q-dialog v-model="Show" persistent @hide="CerrarModal">
    <q-card style="width: 450px; max-width: 90vw;" class="rounded-borders shadow-4">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="currency_exchange" class="q-mr-sm" size="sm" />
          {{ Nuevo ? 'Nuevo Tipo de Cambio' : 'Editar Tipo de Cambio' }}
        </div>
        <q-btn icon="close" flat round dense v-close-popup @click="CerrarModal" />
      </q-card-section>

      <q-card-section class="q-pa-md q-gutter-y-md">
        <q-input
          v-model="NuevaData.FechaCambio2"
          type="date"
          label="Fecha"
          stack-label
          outlined
          dense
        />

        <q-input
          v-model="NuevaData.Compra"
          type="number"
          step="0.001"
          label="Compra"
          outlined
          dense
        />

        <q-input
          v-model="NuevaData.Venta"
          type="number"
          step="0.001"
          label="Venta"
          outlined
          dense
        />
      </q-card-section>

      <q-card-actions align="right" class="q-pa-md bg-grey-1">
        <q-btn
          flat
          label="Cancelar"
          color="grey-7"
          no-caps
          @click="CerrarModal"
        />
        <q-btn
          outline
          color="primary"
          label="Sunat"
          icon="cloud_download"
          no-caps
          :loading="isSunatLoading"
          @click="ObtenerCambioSunat"
        >
          <q-tooltip>Obtener Cambio Sunat</q-tooltip>
        </q-btn>
        <q-btn
          color="primary"
          label="Guardar"
          icon="save"
          unelevated
          no-caps
          :loading="isLoading"
          :disable="EstadoBoton"
          class="text-weight-bold"
          @click="Guardar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "TipoCambioNuevo",
  props: {
    DialogServicio: {
      type: Boolean,
      required: true,
      default: false,
    },
    DiaMes: {
      type: String,
      default: "",
    },
    compra: {
      type: [String, Number],
      default: "",
    },
    venta: {
      type: [String, Number],
      default: "",
    },
    Nuevo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isSunatLoading: false,
      Show: this.DialogServicio,
      EstadoBoton: false,
      NuevaData: {
        FechaCambio2: "",
        Compra: "",
        Venta: "",
      },
    };
  },
  watch: {
    DialogServicio(val) {
      this.Show = val;
      if (val) {
        this.NuevaData.FechaCambio2 = this.DiaMes || "";
        this.NuevaData.Compra = this.compra || "";
        this.NuevaData.Venta = this.venta || "";
      }
    },
  },
  methods: {
    ValidarForm() {
      return true;
    },
    Guardar() {
      if (this.ValidarForm()) {
        let me = this;
        me.isLoading = true;
        me.EstadoBoton = true;
        const endpoint = me.Nuevo
          ? "https://aveoperu.com/dniconsulta/CambioRegistro.php"
          : "https://aveoperu.com/dniconsulta/CambioEditar.php";

        axios
          .get(
            `${endpoint}?FechaCambio2=${me.NuevaData.FechaCambio2}&Compra=${me.NuevaData.Compra}&Venta=${me.NuevaData.Venta}`
          )
          .then((response) => {
            if (response.data && response.data.success === true) {
              me.CerrarModal();
            }
          })
          .catch(function(error) {
            console.error(error);
          })
          .finally(() => {
            me.isLoading = false;
            me.EstadoBoton = false;
          });
      }
    },
    ObtenerCambioSunat() {
      let me = this;
      me.isSunatLoading = true;
      axios
        .get("https://aveoperu.com/dniconsulta/ApiWeb/TipoCambioSunat.php")
        .then(function(response) {
          if (response.data) {
            me.NuevaData.FechaCambio2 = response.data.fecha || me.NuevaData.FechaCambio2;
            me.NuevaData.Compra = response.data.compra || me.NuevaData.Compra;
            me.NuevaData.Venta = response.data.venta || me.NuevaData.Venta;
          }
        })
        .catch(function(error) {
          console.error(error);
        })
        .finally(() => {
          me.isSunatLoading = false;
        });
    },
    CerrarModal() {
      this.Limpiar();
      this.$emit("CerrarModal");
    },
    Limpiar() {
      this.NuevaData = {
        FechaCambio2: "",
        Compra: "",
        Venta: "",
      };
    },
  },
};
</script>
